<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Endpoints
            </h2>
            <small class="title-description">
                Gestion de endpoints
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedEndpoint!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllEndpoints()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>
<form class="card mt-3" [formGroup]="form">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                {{selectedEndpoint&&selectedEndpoint.clave ?
                selectedEndpoint.clave : "Crear"}}
            </h2>
            <small class="title-description">
                {{selectedEndpoint&&selectedEndpoint.valor ?
                selectedEndpoint.valor : "Digite todos los campos"}}
            </small>
        </div>
    </div>
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12 col-md-4">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="clave" type="text" [maxlength]="150"
                (input)="ignoreSpecialCharactersVoid('clave',form.get('clave')?.value)">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-4">
            <mat-label>Valor</mat-label>
            <input matInput formControlName="valor" type="text" [maxlength]="255">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-4">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="estado">
                <mat-option [value]="'A'">Activo</mat-option>
                <mat-option [value]="'I'">Inactivo</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button class="btn btn-secondary" type="button" *ngIf="selectedEndpoint!=undefined"
            (click)="modify()"
            [ngClass]="{'btn-primary': selectedEndpoint==undefined,'btn-secondary': selectedEndpoint!=undefined}">Modificar</button>
        <button mat-flat-button type="button" (click)="create()" class="btn btn-primary">Crear
            nuevo</button>

    </div>
</form>

<div class="shadow mt-3">
    <coky-table [title]="'Listado'" [description]="'Seleccione un registro para modificar'" [data]="endpoints"
        (clickRow)="selectEndpoint($event)" [multipleSelection]="false">
    </coky-table>
</div>